module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ts-grids",
    class: {
      'is-column': _vm.layOut === 'column', 'is-table': _vm.type === 'table', 'is-flexbox': _vm.type === 'flexbox'
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.empty) ? _c('div', {
    staticClass: "ts-empty onepx"
  }, [_c('p', {
    staticClass: "ts-empty-text"
  }, [_vm._v(_vm._s(_vm.emptyText))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-366a1b67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/card/tsGrid.vue
// module id = 820
// module chunks = 39